import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getMuestraSupplierResponsables = async () => {
  const response = await axios.get(
    `${API_URL}/api/muestras-supplier-responsables`,
    {
      headers: getHeaders(),
    }
  );
  return response.data;
};

export const createMuestraSupplierResponsable = async ({ nombre }) => {
  const response = await axios.post(
    `${API_URL}/api/muestras-supplier-responsables`,
    { nombre },
    { headers: getHeaders() }
  );
  return response.data;
};

export const deleteMuestraSupplierResponsable = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/muestras-supplier-responsables/${id}`,
    { headers: getHeaders() }
  );
  return response.data;
};
